import React, { useEffect, useState } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { columnsEnquiry } from "../../Global Functions/columnsAntd";
import { useDispatch, useSelector } from "react-redux";
import { getEnquiriesList } from "../../Redux/Actions/enquiriesAction";
import { useParams } from "react-router-dom";
import TableComponentsCp from "../../Global Functions/tableComponentsCp";

const ListEnquiries = () => {
  const dispatch = useDispatch();

  const { id } = useParams();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = (page, limit) => {
    if (id) {
      const enquiryData = {
        page,
        limit,
        is_deleted: false,
        project_id: id,
      };
      dispatch(getEnquiriesList(enquiryData));
    } else {
      const enquiryData = {
        page,
        limit,
        is_deleted: false,
      };
      dispatch(getEnquiriesList(enquiryData));
    }
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, []);

  const { enquiries } = useSelector((state) => state.enquiries || {});

  useEffect(() => {
    if (enquiries?.total)
      setPagination((prevData) => ({ ...prevData, total: enquiries.total }));
  }, [enquiries]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  return (
    <TableComponentsCp
      columns={columnsEnquiry}
      h3heading="Enquiries List"
      buttonhead2="Go Back"
      navigateTo2="/enquiry"
      pagination={pagination}
      dataSource={Array.isArray(enquiries?.data) ? enquiries.data : []}
      onChange={handleTableChange}
    ></TableComponentsCp>
  );
};

export default ListEnquiries;
